export default function reorder(array, from, to) {
    const result = Array.from(array);
    const [removed] = result.splice(from, 1);
    result.splice(to + (from < to ? -1 : 0), 0, removed);
    return result;
};
